<div
  #modalContents
  [class]="lmodalContentsClassWithWidth"
  aria-modal="true"
  role="dialog"
  aria-labelledby="(modal title)"
>
  <div #modalHead [class]="lmodalHeaderClass">
    <div class="p-modal-head02">
      <h1
        id="meal-application-select-modal-modalTitle2"
        class="p-modal-head02__title p-modal-head02__title--blue"
        [innerHTML]="'label.selectMenu.title' | staticMsg"
      ></h1>
      <button
        id="meal-application-select-modal-head-button1"
        class="p-modal-head02__close js-wModal-close"
        (click)="clickClose()"
      >
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>
  <div #modalBody [class]="lmodalBodyClass">
    <div class="p-modal-menu02">
      <div class="p-modal-menu02__title">
        <h2 class="p-modal-menu02__title-label" [innerHTML]="'label.normalMeal' | staticMsg"></h2>
        <ul class="c-inline-list01">
          <li class="c-inline-list01__item" [innerHTML]="'label.mealMenuDetail.normal' | staticMsg"></li>
        </ul>
      </div>
      <asw-meal-application-select-chargeable [(data)]="info.chargeableMealList" (applyItem)="applyItem($event)">
      </asw-meal-application-select-chargeable>
      <asw-meal-application-select-preorder
        [useBorder]="info.chargeableMealList.length !== 0"
        [(data)]="info.preorderMealList"
        (applyItem)="applyItem($event)"
        [cabin]="payload.cabin"
      >
      </asw-meal-application-select-preorder>
      <asw-meal-application-select-special
        [useBorder]="info.chargeableMealList.length !== 0 || info.preorderMealList.length !== 0"
        [(data)]="info.specialMealList"
        (applyItem)="applyItem($event)"
      >
      </asw-meal-application-select-special>
    </div>
  </div>
</div>
